import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {subscriptionsActions} from "_actions";
import ReactPaginate from "react-paginate";
import { queryStringToObject, objectToQueryString } from "_helpers";
import styles from "./Styles.module.css";

class Subscription extends Component {
    constructor(props) {
        super(props);

        const search = this.props.location.search.substring(1);
        const filterParams = queryStringToObject(search);

        this.state = {
            offset: 0,
            max: 10,
            ...filterParams
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const { max, offset } = this.state;
        dispatch(subscriptionsActions.getAllSubscriptions({max, offset}))
    }

    handlePageSelect = (page) => {
        this.setState(prevState => ({
            offset: page.selected * prevState.max
        }), function() {
            const { max, offset } = this.state;
            this.getSubscriptions({max, offset})
        })
    }

    /**
     * Handles the change of url to retrieve subscriptions based on query params for filtering
     * @param filterParams The parameters for filtering the messages to be retrieved
     */
    getSubscriptions = (filterParams) => {
        const { history } = this.props
        const queryString = objectToQueryString(filterParams);
        history.push({
            pathname: '/subscriptions',
            search: `?${queryString}`
        });
    };

    render() {
        const { all_subscriptions, total } = this.props;
        const { max, offset } = this.state;
        const getOffsetInt = parseInt(offset,10);
        const getMaxInt = parseInt(max, 10);
        let page = getOffsetInt > 0 ? getOffsetInt / getMaxInt : getOffsetInt;
        const totalPages = total && max ? Math.ceil(total / max) : false;
        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <div className={styles.rateContainer}>
                    <Link to="/create-subscription" className={`btn btn-success pull-right ${styles["mb15"]}`}>
                        Create Subscription
                    </Link>
                    <table className="table table-responsive clear-both">
                        <thead>
                        <tr>
                            <th>Currency</th>
                            <th>Amount</th>
                            <th>Description</th>
                            <th>{''}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {total > 0 && all_subscriptions.map(subscription =>
                            <tr key={subscription.id}>
                                <td className={styles.alignMiddle}>
                                    {subscription.currency &&
                                        `${subscription.currency.label} (${subscription.currency.code})`
                                    }
                                    {! subscription.currency &&
                                        'Unavailable'
                                    }
                                </td>
                                <td className={styles.alignMiddle}>{subscription.amount}</td>
                                <td className={styles.alignMiddle}>{subscription.label}</td>
                                <td className={styles.alignMiddle}>
                                    <Link to={`/edit-subscription/${subscription.id}`} className="btn btn-info btn-sm">
                                        Edit Subscription
                                    </Link>
                                </td>
                            </tr>
                        )}
                        {total === 0 &&
                            <tr>
                                <td className={styles.noRates} colSpan="3">
                                    No Subscriptions have been previously added
                                </td>
                            </tr>
                        }
                        </tbody>
                        {totalPages && totalPages > 1 &&
                            <ReactPaginate previousLabel={"<"}
                               nextLabel={">"}
                               breakLabel={<span>...</span>}
                               breakClassName={"break-me"}
                               pageCount={totalPages}
                               marginPagesDisplayed={2}
                               disableInitialCallback={true}
                               pageRangeDisplayed={5}
                               forcePage={page}
                               onPageChange={(page) => this.handlePageSelect(page)}
                               containerClassName={"pagination"}
                               subContainerClassName={"pages pagination"}
                               activeClassName={"active"}
                               activePage={offset / max}
                               handleSelect={this.handleSelect}
                            />
                        }
                    </table>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { subscription: { all_subscriptions, total }} = state;
    return {
        all_subscriptions, total
    };
}

let subscriptionConnect = connect(mapStateToProps)(Subscription);

export { subscriptionConnect as Subscription }